import algoliasearch from 'algoliasearch';

import { IAlgoliaStory, IStory } from 'types/story';

import { sortLowerCase } from 'services/array';

const client = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_API_KEY,
);
const index = client.initIndex(process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME);

export const searchStories = async ({
  term,
  companyId,
  topicFilters,
}: {
  term: string;
  companyId: string;
  topicFilters: string[];
}): Promise<IStory[]> => {
  const topicsString = sortLowerCase(topicFilters).join(',');

  const hits = (
    await index.search(term, {
      filters: `meta.publishedAt>0 AND (meta.companyId:${companyId})`,
      facetFilters: [`meta.topicsPermutations:${topicsString}`],
    })
  ).hits as unknown as IAlgoliaStory[];

  return hits.map(({ objectID, ...story }) => ({
    id: objectID,
    ...story,
    cards: [],
  }));
};
